<script setup>
defineProps({
  error: {
    type: Object,
    default: null,
  },
})

const clerk = useClerk()

async function signOut() {
  try {
    await clerk.value?.signOut()
    await navigateTo('/sign-in', { replace: true })
  } catch (error) {
    console.error(error)
  }
}
</script>

<template>
  <div class="flex flex-col items-center justify-center gap-6 h-screen">
    <TarcLogoBackground />
    <h1 class="text-2xl font-bold">
      Uh oh! Something went wrong.
    </h1>
    <p v-if="error && typeof error.message === 'string'">
      {{ error.message }}
    </p>
    <div class="flex gap-2">
      <UButton
        size="sm"
        to="/sign-in"
        trailing-icon="i-heroicons-arrow-right"
      >
        Go to sign in
      </UButton>
      <UButton
        size="sm"
        variant="soft"
        @click="signOut"
      >
        Sign out
      </UButton>
    </div>
  </div>
</template>
